import graphql__a57a16d3efe072741be7 from "./__generated__/MarketingEmailUnsubscribesViewQuery.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useLazyLoadQuery} from "react-relay/hooks";
import {useOutletContext} from "react-router";
import {useIntl} from "react-intl";
import Panel from "./presentational/Panel";
import Table from "./presentational/table/Table";
import TableHeader from "./presentational/table/TableHeader";
import TableData from "./presentational/table/TableData";
import Link from "./presentational/Link";
import type {MarketingEmailUnsubscribesViewQuery as MarketingEmailUnsubscribesViewQueryType} from "./__generated__/MarketingEmailUnsubscribesViewQuery.graphql";

type Props = {};

const MarketingEmailUnsubscribesView: React.FC<Props> = () => {
    const intl = useIntl();
    const context: any = useOutletContext();
    const marketingEmail = context?.marketingEmail;

    const query = useLazyLoadQuery<MarketingEmailUnsubscribesViewQueryType>(
        graphql__a57a16d3efe072741be7,
        {marketingEmailId: marketingEmail?.id || ''},
        {fetchPolicy: 'store-and-network'}
    );

    const unsubscribes = query.marketingEmailUnsubscribes || [];

    const formatDate = (dateString: string | null) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleString();
    };

    const getContactName = (contact: any) => {
        if (!contact) return '-';
        if (contact.teamName) return contact.teamName;
        return [contact.givenName, contact.familyName].filter(Boolean).join(' ') || '-';
    };

    return (
        <Panel>
            <div className="px-6 py-6">
                <h3 className="text-sm font-medium text-gray-900 mb-3">
                    {intl.formatMessage({id: 'marketingEmail.unsubscribes.title'})}
                </h3>

                {unsubscribes.length === 0 ? (
                    <div className="text-center py-10">
                        <p className="text-gray-900 font-medium">{intl.formatMessage({id: 'marketingEmail.unsubscribes.noUnsubscribes'})}</p>
                        <p className="text-gray-500 text-sm mt-1">{intl.formatMessage({id: 'marketingEmail.unsubscribes.noUnsubscribesDescription'})}</p>
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <Table>
                            <thead>
                                <tr>
                                    <TableHeader>{intl.formatMessage({id: 'marketingEmail.unsubscribes.column.contact'})}</TableHeader>
                                    <TableHeader>{intl.formatMessage({id: 'marketingEmail.unsubscribes.column.unsubscribedAt'})}</TableHeader>
                                    <TableHeader>{intl.formatMessage({id: 'marketingEmail.unsubscribes.column.reason'})}</TableHeader>
                                </tr>
                            </thead>
                            <tbody>
                                {unsubscribes.map((unsubscribe, index) => (
                                    <tr
                                        key={unsubscribe.contactIdentifier}
                                        className={(index % 2 === 0 ? 'bg-white' : 'bg-gray-50')}
                                    >
                                        <TableData>
                                            {unsubscribe.contact ? (
                                                <div>
                                                    <Link to={`/contacts/${unsubscribe.contact.id}`}>
                                                        {getContactName(unsubscribe.contact)}
                                                    </Link>
                                                    {unsubscribe.contact.emailAddress && (
                                                        <p className="text-sm text-gray-500">{unsubscribe.contact.emailAddress}</p>
                                                    )}
                                                </div>
                                            ) : (
                                                '-'
                                            )}
                                        </TableData>
                                        <TableData>{formatDate(unsubscribe.unsubscribedAt)}</TableData>
                                        <TableData>{unsubscribe.unsubscribeReason || '-'}</TableData>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </div>
        </Panel>
    );
};

export default MarketingEmailUnsubscribesView;
